<template>
    <div class="col-md pt-2" v-if="showSubCategories() || !hideDeptPicker">
        <label for="departments" class="sr-only">All Departments</label>
        <select class="form-control" v-model="selectedDepartment" v-if="!hideDeptPicker" id="departments">
            <option value="" selected="selected">All Departments</option>
            <option v-for="department in departmentData.results"
                    v-bind:value="department">
                {{department.name}}
            </option>
        </select>
        <label for="specialties" v-if="showSubCategories()" class="sr-only">All Specialties</label>
        <select class="form-control" v-model="selectedSubCategory" v-if="showSubCategories()" id="specialties">
            <option value="" selected="selected">All Specialties</option>
            <option v-for="subCategory in selectedDepartment.subCategories"
                    v-bind:value="subCategory">
                {{subCategory}}
            </option>
        </select>
    </div>
        <!--<div class="col-md pt-2" v-if="showSubCategories()">
            <select class="form-control" v-model="selectedSubCategory">
                <option value="" selected="selected">All Categories</option>
                <option v-for="subCategory in selectedDepartment.subCategories"
                        v-bind:value="subCategory">
                    {{subCategory}}
                </option>
            </select>
        </div>-->
</template>
<script>
    export default {
        props: ["departmentData", "initialDept", "initialSubCat", "hideDeptPicker"],
        data: function () {
            return {
                departmentList: [],
                selectedDepartment: "",
                selectedSubCategory: ""
            };
        },
        methods: {
            showSubCategories: function () {
                return this.selectedDepartment?.subCategories?.length > 0;
            }
        },
        mounted: function () {
            if (this.departmentData) {
                console.log('data', this.departmentData.results);
                this.departmentList = this.departmentData.results;
            }

            if (this.initialDept) {
                console.log('initial dept found', this.initialDept);
                //this.selectedDepartment = this.departmentList.find(d => d.code === this.initialDept);
            }

            if (this.initialSubCat) {
                console.log('initial subcat found', this.initialSubCat);
                this.selectedSubCategory = this.initialSubCat;
            }
        },
        watch: {
            departmentData: function () {
                this.departmentList = this.departmentData.results;
            },
            initialDept: function (newInitialDept) {
                if (!newInitialDept) {
                    this.selectedDepartment = "";
                    return;
                }
                if (this.departmentList) {
                    const found = this.departmentList.find(d => d.code.localeCompare(newInitialDept, 'en', { sensitivity: 'base' }) === 0);
                    if (found && found !== this.selectedDepartment) {
                        this.selectedDepartment = found;
                    }
                }
            },
            initialSubCat: function (newInitialSubCat) {
                const next = newInitialSubCat || '';
                if (next !== this.selectedSubCategory) {
                    this.selectedSubCategory = next;
                }
            },
            departmentList: function () {
                if (!!this.departmentList && this.initialDept) {
                    const found = this.departmentList.find(d => d.code.localeCompare(this.initialDept, 'en', { sensitivity: 'base' }) === 0);
                    if (found && found !== this.selectedDepartment) {
                        this.selectedDepartment = found;
                    }
                }
            },
            selectedDepartment: function (newDept) {
                if (!newDept) {
                    this.$emit('change:deptfilter', {});
                    return;
                }
                if (this.initialDept !== newDept.code) {
                    this.selectedSubCategory = "";
                    this.$emit('change:deptfilter', {
                        "dept": newDept,
                        "subCat": this.selectedSubCategory
                    });
                }
            },
            selectedSubCategory: function (newSubCat) {
                if (this.initialSubCat !== newSubCat) {
                    this.$emit('change:deptfilter', {
                        "dept": this.selectedDepartment,
                        "subCat": newSubCat
                    });
                }
            }
        }
    };
</script>
